import { service as request } from '@/config/axios/service'
import type { Enterprise, EnterpriseMember } from '@/types/enterprise'
import type { ApiResponse, PageParams, PageResult } from '@/types/common'

// 企业精简信息响应结构
export interface EnterpriseSimpleRespVO {
  activeEnterprise: Enterprise | null
  list: Enterprise[]
}

export function getEnterpriseList() {
  return request<ApiResponse<EnterpriseSimpleRespVO>>({
    url: '/api/v1/member/enterprise/list',
    method: 'get',
  })
}

export function switchEnterprise(enterpriseId: number) {
  return request({
    url: '/api/v1/member/enterprise/switch',
    method: 'post',
    data: { enterpriseId },
  })
}

export function switchToPersonalApi() {
  return request({
    url: '/api/v1/member/enterprise/switch-personal',
    method: 'post',
  })
}

export function getEnterpriseMemberList(params: PageParams & { enterpriseId: number }) {
  return request<ApiResponse<PageResult<EnterpriseMember>>>({
    url: '/api/v1/member/enterprise/member/page',
    method: 'get',
    params,
  })
}

export function addEnterpriseMember(data: { enterpriseId: number; userMobile: string; role: number }) {
  return request({
    url: '/api/v1/member/enterprise/member/add',
    method: 'post',
    data,
  })
}

export function removeEnterpriseMember(id: number) {
  return request({
    url: '/api/v1/member/enterprise/member/delete',
    method: 'delete',
    params: { id },
  })
}

/** 与后端 MemberEnterpriseUserRoleEnum 一致：1 所有者 2 管理员 3 普通成员 */
export function updateEnterpriseMemberRole(data: { id: number; role: number }) {
  return request({
    url: '/api/v1/member/enterprise-user/update',
    method: 'put',
    data,
  })
}

// ==================== 创建企业 ====================

// 创建企业请求参数
export interface EnterpriseCreateParams {
  name: string
  contactName: string
  creditCode: string
  licenseUrl: string
  legalName: string
  legalPersonIdCard: string
}

// 创建企业
export function createEnterprise(data: EnterpriseCreateParams) {
  return request<ApiResponse<number>>({
    url: '/api/v1/member/enterprise/create',
    method: 'post',
    data,
  })
}

// ==================== 企业认证相关接口 ====================

// 企业认证提交参数
export interface EnterpriseVerifySubmitParams {
  enterpriseId: number
  name: string
  creditCode: string
  businessLicenseUrl: string
  legalName: string
  legalIdCard: string
  legalIdCardFrontUrl: string
  legalIdCardBackUrl: string
  contactName: string
  contactMobile: string
}

// 获取企业详情
export function getEnterpriseDetail(enterpriseId: number) {
  return request<ApiResponse<Enterprise>>({
    url: '/api/v1/member/enterprise/get',
    method: 'get',
    params: { id: enterpriseId },
  })
}

// 提交企业认证
export function submitEnterpriseVerify(data: EnterpriseVerifySubmitParams) {
  return request<ApiResponse<any>>({
    url: '/api/v1/member/verify/submit-enterprise',
    method: 'post',
    data,
  })
}
